import { apiGet, apiPost, parseQuery, getHostApi } from './apiWrapper';
import { updateObject, syncWithLocalStorage, getMomentLanguage, isRepiWeb, reloadApiVersion } from './storeFunctions'
import { searchInstances } from './relationsSearchStore';
import { push } from 'react-router-redux'
import { writeDebug, writeErr, writeInfo, writeWarn } from '../components/common/logger';
import { setActiveLanguage } from 'react-localize-redux';

const LOCATION_CHANGE = '@@router/LOCATION_CHANGE'; // hardcoded to save 9KB lib link just to get one value
const requestGetUserContextType = "REQUEST_USER_CONTEXT";
const receiveGetUserContextType = "RECEIVE_USER_CONTEXT";
const toggleNavMenuType = "TOGGLE_NAVMENU";
const userLogin = "USER_LOGIN";
const userLoginReset = "USER_LOGIN_RESET";
export const userLogout = "USER_LOGOUT";
const userLoginRequest = "USER_LOGIN_REQUEST";
const userLoginFailed = "USER_LOGIN_FAILED";
const userExpired = "LOGIN_EXPIRED";
const windowResize = "WINDOW_RESIZE";
const userChangePwd = "USER_CHANGE_PWD";
const userChangePwdBack = "USER_CHANGE_PWD_BACK";
const changingLanguage = "CHANGING_LANGUAGE";
export const languageChanged = "LANGUAGE_CHANGED";
const displaySettingsChanged = "DISPLAY_SETTINGS_CHANGED";
const displaySettingsReset = "DISPLAY_SETTINGS_RESET";
const updateUserInfo = 'UPDATE_USER_INFO';
const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] ||
    (typeof window['safari'] !== 'undefined' && window['safari'].pushNotification));

const DEFAULT_SETTINGS = {
    theme: 'blue',
    reportHeadersStyle: 'square',
    popupHeaderStyle: 'filled',
    tint: 'header',
    loginStyle: 'blue',
    buttonStyle: 'square',
    fontSize: '14px',
    font: 'montserrat',
    urlFormat: 'underline',
    menuActiveStyle: 'square',
    reportWidth: 'fixed',
    reportButtonsFormat: 'full',
    fixedLeftPanel: '1',
    openLastSearched: '1',
    openSectionsConfig: '1',
    openSearchFilter: '1',
    openAlertsFilter: '1',
    openUnicornSections: '1',
    oneUnicornExportSections: '1',
    openSectionsPdfExport: '0'
};

const initSettings = createInitSettings();
const initProfile = { displaySettings: { ...initSettings } };
const initRepi = { allowed: false, allowSharing: false };
const initAuth = { isAuthorized: false, error: undefined, loading: false, profile: { ...initProfile }, repi: { ...initRepi } };
const initialState = restoreFromStorage({ collapsed: true, isLoading: false, isLoaded: false, authentication: { ...initAuth }, language: localStorage.getItem('locales_lang') });

function createInitSettings() {
    const sett = ((JSON.parse(localStorage.getItem('auth') || '{}').profile || {}).displaySettings || {});
    return {
        theme: localStorage.getItem('locales_theme') || sett.theme || DEFAULT_SETTINGS.theme,
        reportHeadersStyle: localStorage.getItem('locales_report_headers_style') || sett.reportHeadersStyle || DEFAULT_SETTINGS.reportHeadersStyle,
        popupHeaderStyle: localStorage.getItem('locales_popup_header_style') || sett.popupHeaderStyle || DEFAULT_SETTINGS.popupHeaderStyle,
        tint: localStorage.getItem('locales_tint') || sett.tint || DEFAULT_SETTINGS.tint,
        loginStyle: localStorage.getItem('locales_login') || sett.loginStyle || DEFAULT_SETTINGS.loginStyle,
        buttonStyle: localStorage.getItem('locales_button_style') || sett.buttonStyle || DEFAULT_SETTINGS.buttonStyle,
        fontSize: localStorage.getItem('font_size') || sett.fontSize || DEFAULT_SETTINGS.fontSize,
        font: localStorage.getItem('font') || sett.font || DEFAULT_SETTINGS.font,
        urlFormat: localStorage.getItem('locales_url_format') || sett.urlFormat || DEFAULT_SETTINGS.urlFormat,
        menuActiveStyle: localStorage.getItem('locales_menu_active_style') || sett.menuActiveStyle || DEFAULT_SETTINGS.menuActiveStyle,
        reportWidth: localStorage.getItem('locales_report_width') || sett.reportWidth || DEFAULT_SETTINGS.reportWidth,
        reportButtonsFormat: localStorage.getItem('locales_report_buttons_format') || sett.reportButtonsFormat || DEFAULT_SETTINGS.reportButtonsFormat,
        fixedLeftPanel: localStorage.getItem('locales_fixed_left_panel') || sett.fixedLeftPanel || DEFAULT_SETTINGS.fixedLeftPanel,
        openLastSearched: localStorage.getItem('locales_right_panel_openLastSearched') || sett.openLastSearched || DEFAULT_SETTINGS.openLastSearched,
        openSectionsConfig: localStorage.getItem('locales_right_panel_openSectionsConfig') || sett.openSectionsConfig || DEFAULT_SETTINGS.openSectionsConfig,
        openSearchFilter: localStorage.getItem('locales_right_panel_openSearchFilter') || sett.openSearchFilter || DEFAULT_SETTINGS.openSearchFilter,
        openAlertsFilter: localStorage.getItem('locales_right_panel_openAlertsFilter') || sett.openAlertsFilter || DEFAULT_SETTINGS.openAlertsFilter,
        openUnicornSections: localStorage.getItem('locales_right_panel_openUnicornSections') || sett.openUnicornSections || DEFAULT_SETTINGS.openUnicornSections,
        oneUnicornExportSections: localStorage.getItem('locales_right_panel_oneUnicornExportSections') || sett.oneUnicornExportSections ||
            DEFAULT_SETTINGS.oneUnicornExportSections,
        openSectionsPdfExport: localStorage.getItem('locales_right_panel_openSectionsPdfExport') || sett.openSectionsPdfExport || DEFAULT_SETTINGS.openSectionsPdfExport
    };
}

function setUpDisplaySettings(ds) {
    localStorage.setItem('locales_theme', ds.theme || DEFAULT_SETTINGS.theme);
    localStorage.setItem('locales_report_headers_style', ds.reportHeadersStyle || DEFAULT_SETTINGS.reportHeadersStyle);
    localStorage.setItem('locales_popup_header_style', ds.popupHeaderStyle || DEFAULT_SETTINGS.popupHeaderStyle);
    localStorage.setItem('locales_tint', ds.tint || DEFAULT_SETTINGS.tint);
    localStorage.setItem('locales_login', ds.loginStyle || DEFAULT_SETTINGS.loginStyle);
    localStorage.setItem('locales_button_style', ds.buttonStyle || DEFAULT_SETTINGS.buttonStyle);
    localStorage.setItem('font_size', ds.fontSize || DEFAULT_SETTINGS.fontSize);
    localStorage.setItem('font', ds.font || DEFAULT_SETTINGS.font);
    localStorage.setItem('locales_url_format', ds.urlFormat || DEFAULT_SETTINGS.urlFormat);
    localStorage.setItem('locales_menu_active_style', ds.menuActiveStyle || DEFAULT_SETTINGS.menuActiveStyle);
    localStorage.setItem('locales_report_width', ds.reportWidth || DEFAULT_SETTINGS.reportWidth);
    localStorage.setItem('locales_report_buttons_format', ds.reportButtonsFormat || DEFAULT_SETTINGS.reportButtonsFormat);
    localStorage.setItem('locales_fixed_left_panel', ds.fixedLeftPanel || DEFAULT_SETTINGS.fixedLeftPanel);
    localStorage.setItem('locales_right_panel_openLastSearched', ds.openLastSearched || DEFAULT_SETTINGS.openLastSearched);
    localStorage.setItem('locales_right_panel_openSectionsConfig', ds.openSectionsConfig || DEFAULT_SETTINGS.openSectionsConfig);
    localStorage.setItem('locales_right_panel_openSearchFilter', ds.openSearchFilter || DEFAULT_SETTINGS.openSearchFilter);
    localStorage.setItem('locales_right_panel_openAlertsFilter', ds.openAlertsFilter || DEFAULT_SETTINGS.openAlertsFilter);
    localStorage.setItem('locales_right_panel_openUnicornSections', ds.openUnicornSections || DEFAULT_SETTINGS.openUnicornSections);
    localStorage.setItem('locales_right_panel_oneUnicornExportSections', ds.oneUnicornExportSections || DEFAULT_SETTINGS.oneUnicornExportSections);
    localStorage.setItem('locales_right_panel_openSectionsPdfExport', ds.openSectionsPdfExport || DEFAULT_SETTINGS.openSectionsPdfExport);
}

function removeSavedSearchSubjects() {
    Object.values(searchInstances).forEach((key) => {
        localStorage.removeItem(key);
    });

    localStorage.removeItem("relationsFilter");
}

//action creator for redux
export const userContextActions = {
    toggle: () => async (dispatch, getState) => {
        dispatch({ type: toggleNavMenuType, data: { collapsed: !getState().userContext.collapsed } });
    },
    fetchTranslations: (language, addTranslationForLanguage, setAsActive) => async (dispatch) => {
        getLanguageData(language, addTranslationForLanguage, setAsActive, dispatch);
    },
    fetchHelp: () => async () => {
        apiGet(window.babylonApiUrl + `/api/account/help-map`, null, res => {
            syncWithLocalStorage('help_map', res.data)
        });
    },
    login: (username, pswd, url, guid, smsToken) => async (dispatch, getState) => {
        if (getState().userContext.authentication.loading)
            return;
        dispatch({ type: userLoginRequest });
        apiPost(window.babylonApiUrl + `/api/account/login`, undefined, {
            username: username,
            password: pswd,
            grant_type: 'password',
            guid: guid,
            sms_token: smsToken,
            safari: isSafari,
            repi: isRepiWeb()
        }, res => {
            if (!res.data.success) {
                dispatch({ type: userLoginFailed, data: res.data });
            } else {
                dispatch({ type: userLogin, data: res.data });
                redirectTo(dispatch, url);
            }
        }, err => {
            writeErr(err);
            dispatch({ type: userLoginFailed, data: { success: false, errorMessage: "UnhappyUser.InternalServerError" } });
        });
    },
    verify: (consent, guid, url) => async (dispatch, getState) => {
        if (getState().userContext.authentication.loading) {
            return;
        }
        dispatch({ type: userLoginRequest });
        apiPost(window.babylonApiUrl + `/api/account/verify`, undefined, { consent: consent, guid: guid }, res => {
            if (!res.data.success) {
                dispatch({ type: userLoginFailed, data: res.data });
            } else {
                dispatch({ type: userLogin, data: res.data });
                redirectTo(dispatch, url);
            }
        }, err => {
            writeErr(err);
            dispatch({ type: userLoginFailed, data: { success: false, errorMessage: "UnhappyUser.InternalServerError" } });
        });
    },
    loginSsoToken: (ssoToken, lang, url, addTranslationForLanguage, autologinToken, guid, smsToken) => async (dispatch, getState) => {
        if (getState().userContext.authentication.loading) {
            return;
        }
        dispatch({ type: userLoginRequest });
        apiPost(window.babylonApiUrl + `/api/account/login-sso-token`, { ssoToken: ssoToken, autologinToken: autologinToken, guid: guid, smsToken: smsToken }, undefined, res => {
            if (!res.data.success) {
                dispatch({ type: userLoginFailed, data: res.data });
            } else {
                dispatch({ type: userLogin, data: res.data });
                getLanguageData(lang, addTranslationForLanguage, true, dispatch);
                redirectTo(dispatch, url);
            }
        }, err => {
            writeErr(err);
            dispatch({ type: userLoginFailed, data: { success: false, errorMessage: "UnhappyUser.InternalServerError" } });
        });
    },
    loginSsoHyperlink: (ssoToken, lang, url, addTranslationForLanguage, isLimited, returnUrl, guid, smsToken) => async (dispatch, getState) => {
        if (getState().userContext.authentication.loading) {
            return;
        }
        dispatch({ type: userLoginRequest });
        apiPost(window.babylonApiUrl + `/api/account/login-sso-hyperlink`, undefined, { ssoToken: ssoToken, guid: guid, sms_token: smsToken, isLimited: isLimited, returnUrl: returnUrl }, res => {
            if (!res.data.success) {
                dispatch({ type: userLoginFailed, data: res.data });
            } else {
                dispatch({ type: userLogin, data: res.data });
                getLanguageData(lang, addTranslationForLanguage, true, dispatch);
                redirectTo(dispatch, url);
            }
        }, err => {
            writeErr(err);
            dispatch({ type: userLoginFailed, data: { success: false, errorMessage: "UnhappyUser.InternalServerError" } });
        });
    },

    updateDisplaySettings: (key, localStorageKey, value) => async (dispatch) => {
        localStorage.setItem(localStorageKey, value);
        dispatch({ type: displaySettingsChanged, value, key });
    },
    resetDisplaySettings: () => async (dispatch) => {
        const settings = [
            { key: 'theme', localStorageKey: 'locales_theme', value: DEFAULT_SETTINGS.theme },
            { key: 'reportHeadersStyle', localStorageKey: 'locales_report_headers_style', value: DEFAULT_SETTINGS.reportHeadersStyle },
            { key: 'popupHeaderStyle', localStorageKey: 'locales_popup_header_style', value: DEFAULT_SETTINGS.popupHeaderStyle },
            { key: 'tint', localStorageKey: 'locales_tint', value: DEFAULT_SETTINGS.tint },
            { key: 'buttonStyle', localStorageKey: 'locales_button_style', value: DEFAULT_SETTINGS.buttonStyle },
            { key: 'fontSize', localStorageKey: 'font_size', value: DEFAULT_SETTINGS.fontSize },
            { key: 'font', localStorageKey: 'font', value: DEFAULT_SETTINGS.font },
            { key: 'urlFormat', localStorageKey: 'locales_url_format', value: DEFAULT_SETTINGS.urlFormat },
            { key: 'menuActiveStyle', localStorageKey: 'locales_menu_active_style', value: DEFAULT_SETTINGS.menuActiveStyle },
            { key: 'reportWidth', localStorageKey: 'locales_report_width', value: DEFAULT_SETTINGS.reportWidth },
            { key: 'reportButtonsFormat', localStorageKey: 'locales_report_buttons_format', value: DEFAULT_SETTINGS.reportButtonsFormat },
        ];

        settings.forEach(setting => localStorage.setItem(setting.localStorageKey, setting.value));
        dispatch({ type: displaySettingsReset, settings: Object.assign({}, ...settings.map(setting => ({ [setting.key]: setting.value }))) });
    },

    updateFixedLeftPanel: (value) => async (dispatch) => {
        localStorage.locales_fixed_left_panel = value;
        dispatch({ type: displaySettingsChanged, value: value, key: 'fixedLeftPanel' });
    },

    updateOpenRightPanel: (id, value) => async (dispatch) => {
        localStorage.setItem(`locales_right_panel_${id}`, value);
        dispatch({ type: displaySettingsChanged, value: value, key: id });
    },

    logout: () => async (dispatch, getState) => {
        localStorage.removeItem('auth');
        localStorage.removeItem('checkNews');
        localStorage.removeItem('repi_consents');
        removeSavedSearchSubjects();
        dispatch({ type: userLogout })
        redirectTo(dispatch, '/login');
    },
    changePwd: () => async (dispatch, getState) => {
        dispatch({ type: userChangePwd })
        redirectTo(dispatch, '/login');
    },
    changePwdBack: () => async (dispatch, getState) => {
        dispatch({ type: userChangePwdBack })
        redirectTo(dispatch, document.referrer);
    },
    redirectBack: (url) => async (dispatch, getState) => redirectTo(dispatch, url),
    resetLoginAttempt: () => async (dispatch, getState) => dispatch({ type: userLoginReset }),
    updateUserInfo: userUpdateData => async dispatch => dispatch({ type: updateUserInfo, userUpdateData }),
    syncSettings: (changed) => async () => {
        apiPost(getHostApi() + '/api/account/update-user-profile', undefined, { ...changed }, (_) => { }, (err) => { writeErr(err) }, () => { });
    }
};

// store reducer
export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case changingLanguage:
            return updateObject(state, { langLoading: true });
        case languageChanged:
            return updateObject(state, { langLoading: false, language: action.language });
        case windowResize:
            return updateObject(state, { resized: action.event });
        case requestGetUserContextType:
        case receiveGetUserContextType:
        case toggleNavMenuType:
            return updateObject(state, action.data);
        case LOCATION_CHANGE:
            return { ...state, location: action.payload.pathname };
        case userLoginRequest:
            return updateObject({ ...state, isChangePwd: false }, { authentication: updateObject(state.authentication, { loading: true, error: undefined }) });
        case userLogin:
            let dataul = { isAuthorized: action.data.success, ...action.data, requestTime: new Date().toISOString(), loading: false };
            try {
                if (Math.abs(new Date(dataul.requestTime) - new Date(dataul.issuedOn)) >= 900000) {
                    writeWarn('Detected more than 15 minutes difference betweem local and server time', { localTime: dataul.requestTime, serverTime: dataul.issuedOn });
                }
            } catch (e) { writeErr('time detection failed', e); }
            localStorage.setItem('auth', JSON.stringify(dataul));
            localStorage.setItem('checkNews', true);
            setUpDisplaySettings(((dataul.profile || {}).displaySettings || {}));
            dataul.profile.displaySettings = { ...DEFAULT_SETTINGS, ...dataul.profile.displaySettings };
            reloadApiVersion(action.data.apiVersion);
            return updateObject({ ...state, isLoaded: false, isLoading: false }, { authentication: updateObject(state.authentication, dataul) });
        case userExpired:
            localStorage.removeItem('auth');
            localStorage.removeItem('checkNews');
            return updateObject(state, { authentication: { ...initAuth } });
        case userLoginFailed:
            let dataulf = { isAuthorized: action.data.success, ...action.data, loading: false };
            return updateObject({ ...state, isLoading: false }, { authentication: updateObject(state.authentication, dataulf) })
        case userLogout:
            return { ...state, isChangePwd: false, authentication: { ...initAuth } };
        case userLoginReset:
            return updateObject(state, { authentication: updateObject(state.authentication, { error: undefined }) });
        case userChangePwd:
            return { ...state, isChangePwd: true, authentication: { ...initAuth, profile: state.authentication.profile } };
        case userChangePwdBack:
            let tmpAuth = state.authentication;
            return { ...state, isChangePwd: undefined, authentication: tmpAuth };
        case displaySettingsChanged:
            return updateObject(state, {
                authentication: updateObject(state.authentication,
                    {
                        profile: updateObject(state.authentication.profile, {
                            displaySettings: updateObject(state.authentication.profile.displaySettings,
                                { [action.key]: action.value })
                        })
                    })
            });
        case displaySettingsReset:
            return updateObject(state, {
                authentication: updateObject(state.authentication,
                    {
                        profile: updateObject(state.authentication.profile, {
                            displaySettings: updateObject(state.authentication.profile.displaySettings, action.settings)
                        })
                    })
            });
        case updateUserInfo:
            state = {
                ...state, ...{
                    authentication: {
                        ...state.authentication, profile: { ...state.authentication.profile, ...action.userUpdateData }
                    }
                }
            };
            localStorage.setItem('auth', JSON.stringify(state.authentication));
            return state;
        default:
            return state;
    }
}

function getLanguageData(language, addTranslationForLanguage, setAsActive, dispatch) {
    const locData = localStorage.getItem('locales_data');
    const locLang = localStorage.getItem('locales_lang');
    const locVersion = localStorage.getItem('locales_version');

    dispatch({ type: changingLanguage });
    if (locLang === language) {
        if (locData !== null && locData !== undefined) {
            dispatch(addTranslationForLanguage(JSON.parse(locData), language));
            apiGet(`/lang/${language}`, { version: true }, res => {
                if (res.version !== locVersion) {
                    writeDebug(`Local translations with version:[${locVersion}] is out-of-date loading fresh data`);
                    apiGet(`/lang/${language}`, { version: true, data: true }, res => {
                        localStorage.setItem('locales_data', JSON.stringify(res.data));
                        localStorage.setItem('locales_version', res.version);
                        dispatch(addTranslationForLanguage(res.data, language));
                        if (setAsActive === true) {
                            dispatch(setActiveLanguage(language));
                        }
                        dispatch({ type: languageChanged, language: language });
                        setHtmlLanguage(language);
                    });
                } else {
                    writeDebug(`Using local translations with version:[${locVersion}]`)
                    dispatch({ type: languageChanged, language: language });
                    setHtmlLanguage(language);
                }
            });
        } else {
            writeDebug(`Local translations not found loading`);
            apiGet(`/lang/${language}`, { version: true, data: true }, res => {
                localStorage.setItem('locales_data', JSON.stringify(res.data));
                localStorage.setItem('locales_version', res.version);
                dispatch(addTranslationForLanguage(res.data, language));
                if (setAsActive === true) {
                    dispatch(setActiveLanguage(language));
                }
                dispatch({ type: languageChanged, language: language });
                setHtmlLanguage(language);
            });
        }
    } else {
        writeDebug(`Local translations language does not match loading fresh data`);
        apiGet(`/lang/${language}`, { version: true, data: true }, res => {
            localStorage.setItem('locales_data', JSON.stringify(res.data));
            localStorage.setItem('locales_lang', language);
            UC_UIUpdateLanguage(getMomentLanguage(language));
            localStorage.setItem('locales_version', res.version);
            dispatch(addTranslationForLanguage(res.data, language));
            if (setAsActive === true) {
                dispatch(setActiveLanguage(language));
            }
            dispatch({ type: languageChanged, language: language });
            setHtmlLanguage(language);
        });
    }
}

function setHtmlLanguage(lang) {
    const current = ((
        (
            (window.document.children || [])[0] ||
            (window.document.childNodes || [])[1] ||
            {}).attributes || {}).lang || {}).value;
    if (current !== null && current !== undefined) {
        if ((window.document.children || [])[0] !== undefined) { //chrome
            window.document.children[0].attributes.lang.value = getMomentLanguage(lang) || 'en';
        } else if ((window.document.childNodes || [])[1] !== undefined) { //IE
            window.document.childNodes[1].attributes.lang.value = getMomentLanguage(lang) || 'en';
        }
    }
}

function restoreFromStorage(initial) {
    let auth = localStorage.getItem('auth');
    if (auth !== null && auth !== undefined) {
        auth = JSON.parse(auth);
        if (auth === null || auth === undefined) {
            return initial;
        } else {
            // use current display settings... otherwise (old)settings from login result will be used
            auth.profile = updateObject(auth.profile, { displaySettings: initial.authentication.profile.displaySettings });
        }

        if (Date.parse(auth.expire) < Date.now() || auth.profile === undefined) {
            localStorage.removeItem('auth');
            localStorage.removeItem('checkNews');
            return initial;
        }
    }

    return updateObject(initial, {
        authentication: updateObject(initial.authentication, { ...auth, loading: false }),
    });
}

function redirectTo(dispatch, url, defaultPath = "/") {
    const q = parseQuery(url);
    const redir = q.returnUrl !== null && q.returnUrl !== undefined ? decodeURIComponent(q.returnUrl) : defaultPath;
    writeDebug("Redirecting to " + redir);
    dispatch(push(redir));
}

function UC_UIUpdateLanguage(language) {
    let lang = language.slice(0, 2);
    if (window.UC_UI && window.UC_UI.isInitialized()) {
        window.UC_UI.updateLanguage(lang);

    } else {
        window.addEventListener('UC_UI_INITIALIZED', function (e) {
            window.UC_UI.updateLanguage(lang);
        });
    }
}